import { gql } from "@apollo/client";

const pager = gql`
  fragment pager on Page {
    afterId
    sortBy
    direction
    pageSize
  }
`;

const pagination = gql`
  fragment pagination on Pagination {
    totalCount
    prevPage {
      ...pager
    }
    nextPage {
      ...pager
    }
  }
  ${pager}
`;

const exp = { pager, pagination };
export default exp;
